<template>
  <div v-bind="$attrs" id="signature-block" class="columns is-multiline">
    <div class="column pt-0 is-full is-italic mb-3 signature-acknowledgement">
      I have read and understood the {{sectionName}} and hereby agree to the terms.
    </div>
    <div class="column pb-0" :class="columnSize" v-if="hasName">
      <div class="signature-line">
        <span class="is-size-7 pt-2">Name</span>
      </div>
    </div>
    <div class="column pb-0" :class="columnSize" v-if="hasSignature">
      <div class="signature-line">
        <span class="is-size-7 pt-2">Signature</span>
      </div>
    </div>
    <div class="column pb-0" :class="columnSize" v-if="hasInitial">
      <div class="signature-line">
        <span class="is-size-7 pt-2">Initial</span>
      </div>
    </div>
    <div class="column pb-0" :class="columnSize" v-if="hasDate">
      <div class="signature-line">
        <span class="is-size-7 pt-2">Date</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    sectionName: {
      type: String
    },
    hasName: {
      type: Boolean,
      default: true
    },
    hasSignature: {
      type: Boolean,
      default: true
    },
    hasInitial: {
      type: Boolean,
      default: false
    },
    hasDate: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    columnSize({ hasName, hasSignature, hasInitial, hasDate }) {
      let total = hasName + hasSignature + hasInitial + hasDate;
      return `is-${Math.min(12/total, 6)}`
    }
  }
}
</script>

<style scoped lang="scss">
.signature-line {
  border-top: 1px solid #ccc;
}

.signature-acknowledgement {
  font-size: 0.8em;
}

#signature-block {
  page-break-inside: avoid;
}
</style>